(function () {
  'use strict';

  var STORAGE_KEY  = 'as_cart_reminder_ts';
  var DELAY_MS     = 1800;           // wait 1.8s after page load before showing

  // يظهر كل مرة يدخل الزبون (بدون cooldown)
  function shouldShow() {
    return true;
  }

  function markShown() {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  function buildReminder(cart) {
    var item  = cart.items[0];
    var count = cart.item_count;

    var el = document.createElement('div');
    el.id = 'cart-reminder';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.className = 'cart-reminder__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', function () { hideReminder(el); });

    // Image
    var imgWrap;
    if (item.featured_image && item.featured_image.url) {
      imgWrap = document.createElement('img');
      imgWrap.className = 'cart-reminder__img';
      imgWrap.src = item.featured_image.url;
      imgWrap.alt = item.product_title;
    } else {
      imgWrap = document.createElement('div');
      imgWrap.className = 'cart-reminder__img--placeholder';
      imgWrap.textContent = '🛒';
    }

    // Body
    var body = document.createElement('div');
    body.className = 'cart-reminder__body';

    var label = document.createElement('div');
    label.className = 'cart-reminder__label';
    label.textContent = 'لديك منتجات في سلتك';

    var title = document.createElement('div');
    title.className = 'cart-reminder__title';
    title.textContent = item.product_title;

    var countEl = document.createElement('div');
    countEl.className = 'cart-reminder__count';
    countEl.textContent = count > 1 ? count + ' منتجات في السلة' : 'منتج واحد في السلة';

    var btn = document.createElement('a');
    btn.className = 'cart-reminder__btn';
    btn.href = '/cart';
    btn.textContent = 'عرض السلة';

    body.appendChild(label);
    body.appendChild(title);
    body.appendChild(countEl);
    body.appendChild(btn);

    el.appendChild(closeBtn);
    el.appendChild(imgWrap);
    el.appendChild(body);

    return el;
  }

  function hideReminder(el) {
    el.classList.remove('cart-reminder--visible');
    el.classList.add('cart-reminder--hiding');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 500);
  }

  function showReminder(cart) {
    var el = buildReminder(cart);
    document.body.appendChild(el);
    // Trigger entrance
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('cart-reminder--visible');
      });
    });
    markShown();
    // Auto-hide after 8 seconds
    setTimeout(function () {
      if (document.getElementById('cart-reminder')) hideReminder(el);
    }, 8000);
  }

  function init() {
    if (!shouldShow()) return;
    // Don't show on cart or checkout pages
    var path = window.location.pathname;
    if (path === '/cart' || path.indexOf('/checkouts') !== -1) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          setTimeout(function () { showReminder(cart); }, DELAY_MS);
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
